import { isNil } from 'es-toolkit';
import type { Mapping } from './match-template';
import type { XlsFile } from './xls-file';

export function prepareColumns(xlsFile: XlsFile, mapping?: Mapping, colsToHide?: string[]): void {
  trimColumns(xlsFile, colsToHide);
  sortColumns(xlsFile, mapping);
}

function trimColumns(xlsFile: XlsFile, colsToHide: string[] = []): void {
  const emptyColumns = xlsFile.columns.filter(
    (column: string) =>
      !xlsFile.rows.some((row: Record<string, unknown>) => hasColumnValue(row[column]))
  );
  xlsFile.removeColumns([...colsToHide, ...emptyColumns]);
}

function sortColumns(xlsFile: XlsFile, columnMapping?: Mapping): void {
  function columnInMapping(column: string, mappingData?: Mapping): number {
    return mappingData && Object.keys(mappingData).includes(column) ? 1 : 0;
  }

  function columnHasData(column: string, rows: Record<string, unknown>[]): number {
    return rows.some(row => hasColumnValue(row[column])) ? 1 : 0;
  }

  xlsFile.sortColumns((a: string, b: string) => {
    return (
      columnInMapping(b, columnMapping) - columnInMapping(a, columnMapping) ||
      columnHasData(b, xlsFile.rows) - columnHasData(a, xlsFile.rows)
    );
  });
}

function hasColumnValue(value: unknown): boolean {
  return !(isNil(value) || value === '');
}
